<template>
	<div class="development-guide-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.business_development_page_v2.sec_01.title.one') }}
				</h2>
				<p>
					{{ $t('new_ui.business_development_page_v2.sec_01.desc.one') }}
				</p>
			</div>
		</section>
		<section class="sec-02">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.business_development_page_v2.sec_02.title.one') }}
				</h3>
				<div class="step-box">
					<ul>
						<li>
							<img :src="img.imgDevelopmentStep01" alt="" />
							<p>
								<strong>
									{{
										$t(
											'new_ui.business_development_page_v2.sec_02.step.one.one',
										)
									}}</strong
								><br />
								{{
									$t('new_ui.business_development_page_v2.sec_02.step.one.two')
								}}<br />
								{{
									$t(
										'new_ui.business_development_page_v2.sec_02.step.one.three',
									)
								}}
							</p>
						</li>
						<li v-if="isMobile">
							<img :src="img.imgDot" alt="" />
						</li>
						<li>
							<img :src="img.imgDevelopmentStep02" alt="" />
							<p>
								<strong>
									{{
										$t(
											'new_ui.business_development_page_v2.sec_02.step.two.one',
										)
									}}</strong
								><br />
								{{
									$t('new_ui.business_development_page_v2.sec_02.step.two.two')
								}}<br />
								{{
									$t(
										'new_ui.business_development_page_v2.sec_02.step.two.three',
									)
								}}
							</p>
						</li>
						<li v-if="isMobile">
							<img :src="img.imgDot" alt="" />
						</li>
						<li>
							<img :src="img.imgDevelopmentStep03" alt="" />
							<p>
								<strong>
									{{
										$t(
											'new_ui.business_development_page_v2.sec_02.step.three.one',
										)
									}}</strong
								><br />
								{{
									$t(
										'new_ui.business_development_page_v2.sec_02.step.three.two',
									)
								}}<br />
								{{
									$t(
										'new_ui.business_development_page_v2.sec_02.step.three.three',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.business_development_page_v2.sec_02.step.three.four',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.business_development_page_v2.sec_02.step.three.five',
									)
								}}
							</p>
						</li>
						<li v-if="isMobile">
							<img :src="img.imgDot" alt="" />
						</li>
						<li>
							<img :src="img.imgDevelopmentStep04" alt="" />
							<p>
								<strong>
									{{
										$t(
											'new_ui.business_development_page_v2.sec_02.step.four.one',
										)
									}}</strong
								>
							</p>
						</li>
					</ul>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgDevelopmentStep01 from '@/assets/images/v2/img-development-step-01.png';
import imgDevelopmentStep02 from '@/assets/images/v2/img-development-step-02.png';
import imgDevelopmentStep03 from '@/assets/images/v2/img-development-step-03.png';
import imgDevelopmentStep04 from '@/assets/images/v2/img-development-step-04.png';
import imgDot from '@/assets/images/v2/img-dot.png';

export default {
	data: () => {
		return {
			mobile: window.innerWidth <= 768,
			img: {
				imgDevelopmentStep01,
				imgDevelopmentStep02,
				imgDevelopmentStep03,
				imgDevelopmentStep04,
				imgDot,
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
	},
};
</script>
